/* eslint-disable no-shadow */
import { Box, FormControl, TextField, withStyles } from '@material-ui/core';
import { chatSearchActions } from '@src/reducers/chatSearch';
import { activeChatSideSelector } from '@src/selectors/chats';
import { preferencesSelect } from '@src/selectors/preferences';
import { RootState } from '@src/store/reduxstore';
import { useMemo } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import './styles.css';

type ChatSearchProps = {
  intl: IntlShape;
};

const TextFieldStyled = withStyles(theme => ({
  root: {
    color: theme.b2chatgray[400],
    '& fieldset': {
      borderRadius: '20px',
      borderColor:
        theme.palette.type === 'dark' ? 'rgba(255,255,255,0.15)' : undefined,
    },
    '& .MuiOutlinedInput-root': {
      borderRadius: '20px',
    },
    '& .MuiOutlinedInput-adornedStart': {
      display: 'flex',
      alignItems: 'center',
    },
  },
}))(TextField);

const ChatSearch: React.FC<ChatSearchProps> = ({ intl }) => {
  const { formatMessage } = intl;
  const dispatch = useDispatch();

  const preferences = useSelector(preferencesSelect);
  const activeChatSide = useSelector(activeChatSideSelector);

  const conversationFiltersAlarmHours = useMemo(
    () => preferences?.conversationFiltersAlarmHours || 1,
    [preferences.conversationFiltersAlarmHours]
  );

  const changeContactName = (value: string) => {
    dispatch(
      chatSearchActions.changeChatsFilters({
        filters: { contactName: value },
        chatSide: activeChatSide,
      })
    );
  };

  const { contactName = '' } = useSelector(
    (state: RootState) => state.chatsSearch.filters[activeChatSide] || {}
  );

  return (
    <Box
      p="16px 0px"
      display="flex"
      flexDirection="column"
      style={{ gap: '8px' }}
    >
      <FormControl variant="outlined" fullWidth>
        <TextFieldStyled
          fullWidth
          variant="outlined"
          value={contactName}
          data-testid="chat-search-text-input"
          onChange={({ target }) => changeContactName(target.value)}
          placeholder={formatMessage(
            {
              id: 'Console.ChatSearch.Input.PlaceHolder',
            },
            { hours: conversationFiltersAlarmHours }
          )}
          size="small"
          InputProps={{ style: { padding: '0 10px' } }}
        />
      </FormControl>
    </Box>
  );
};

export default injectIntl(ChatSearch);
